// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Zp7N7","content":"styles_content__vBiba"};